import React from "react";
import { Grid } from "@mui/material";
import { Post } from "../../Confidence/LearningCenter/Post";
import { PostType, TagType } from "../../../types";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { useStyles } from "./HighlightsPosts.styles";
import _ from "lodash"

//@ts-ignore
import htmlToFormattedText from "html-to-formatted-text";

interface HighlightsPostsProps {
	posts: PostType[],
	tags: TagType[]
}

export function HighlightsPosts({ posts, tags }: HighlightsPostsProps) {
	const { classes } = useStyles()
	const isMobile = useIsMobile('md')

	const post: PostType = _.orderBy(posts, [(p: PostType) => p.publishDate], ['desc'])[0]
	const tag: TagType = tags?.find((tag: any) => tag.id === String(post?.tagIds ? post?.tagIds[0] : 0)) || {}

	if (!post) {
		return <></>
	}

	return (
		<section className={classes.root}>
			<Grid container className={classes.container}>
				<Grid item xs={12}>
					<Post
						post={post}
						tag={tag}
						fullWidth={!isMobile}
						className={classes.post}
						imageProps={{
							loadingType: 'eager'
						}}
					/>
				</Grid>
			</Grid>
		</section>
	)
}